import { Controller } from "@hotwired/stimulus"
import GLightbox from "glightbox"
import Plyr from "plyr"

// GLightbox plays video through Plyr, and injects it from cdn.plyr.io the first
// time a video slide opens. Its injectAssets() no-ops once window.Plyr exists,
// so bundling Plyr here keeps the runtime free of third-party fetches — and
// keeps working if the CSP ever moves off report-only.
window.Plyr = Plyr

export default class extends Controller {
  connect() {
    // GLightbox binds its click handler on a document-wide selector rather than
    // within this element, so a page must hold only one gallery.
    this.lightbox = GLightbox({
      selector: "a.glightbox",
      loop: true,
      openEffect: "fade",
      closeEffect: "fade",
      slideEffect: "fade",
    })
  }

  disconnect() {
    this.lightbox?.destroy()
  }
}
